<template>
    <div id="accountCreationDesktop">
        <div class="account-creation-body">
            <Panel :title="$t('account_creation.title')">
                <div class="top">
                    <div class="details-left">
                        <div class="group">
                            <div class="description">{{ $t("account_creation.description") }}</div>
                        </div>

                        <div class="group">
                            <label for="txtNameDesktop">{{ $t("account_creation.name") }}<Tooltip :text="$t('account_creation.tooltip.name')"></Tooltip></label>
                            <input id="txtNameDesktop" type="text" v-model="account.name" :class="{invalid: $validate.error('account.name')}">
                        </div>

                        <div class="group">
                            <label for="txtAccountCreation">{{ $t("account_creation.email") }}<Tooltip :text="$t('account_creation.tooltip.email')"></Tooltip></label>
                            <input id="txtAccountCreation" type="text" v-model="account.email" :class="{invalid: $validate.error('account.email')}">
                        </div>

                        <div class="group">
                            <label for="txtPhoneDesktop">{{ $t("account_creation.phone") }}<Tooltip :text="$t('account_creation.tooltip.phone')"></Tooltip></label>
                            <input id="txtPhoneDesktop" type="text" v-model="account.phone" :class="{invalid: $validate.error('account.phone')}">
                        </div>
                    </div>

                    <div class="details-right">
                        <div class="group">
                            <label for="txtAddressDesktop">{{ $t("account_creation.address") }}<Tooltip :text="$t('account_creation.tooltip.address')"></Tooltip></label>
                            <input id="txtAddressDesktop" type="text" v-model="account.address" :class="{invalid: $validate.error('account.address')}">
                        </div>

                        <div class="group">
                            <label for="txtUnitDesktop">{{ $t("account_creation.unit") }}<Tooltip :text="$t('account_creation.tooltip.unit')"></Tooltip></label>
                            <input id="txtUnitDesktop" type="text" v-model="account.unit" :class="{invalid: $validate.error('account.unit')}">
                        </div>

                        <div class="group">
                            <label for="txtNoteDesktop">{{ $t("account_creation.note") }}<Tooltip :text="$t('account_creation.tooltip.note')"></Tooltip></label>
                            <textarea name="txtNoteDesktop" id="txtNoteDesktop" rows="4" v-model="account.note"></textarea>
                        </div>
                    </div>
                </div>
            </Panel>
        </div>

        <div class="buttons">
            <div @click="back" class="btn btn-secondary">{{ $t("navigation.back") }}</div>
            <div @click="send" class="btn btn-primary">{{ $t("navigation.send") }}</div>
        </div>

    </div>
</template>

<script>
    import Panel from "../Panel";
    import Tooltip from "../../components/Tooltip";

    export default {

        name: "accountCreationDesktop",

        props: {
            account: Object,

            back: Function,
            send: Function,
        },

        components: {
            Panel,
            Tooltip
        },

        validate: {
            "account.name": {
                required: true
            },
            "account.email": {
                required: true,
                email: true
            },
            "account.address": {
                required: true
            },
            "account.unit": {
                required: true
            },
            "account.phone": {
                required: true,
                phone: true
            }
        },

    }

</script>

<style lang="scss" scoped>

    #accountCreationDesktop {
        background-color: #f2f3f4;
        padding: 30px 60px 30px 60px;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        position: relative;
    }

    input, textarea, select {
        width: 100%;
    }

    .account-creation-body {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    .top {
        display: flex;
        flex-shrink: 0;
        & > div:not(:last-of-type) {
            margin-right: 40px;
        }
    }

    .details-left {
        flex-shrink: 0;
        flex-grow: 1;
        flex-basis: 0;
    }

    .details-right {
        flex-grow: 1;
        flex-basis: 0;
        .group {
            flex-grow: 1;
        }
    }

    .group {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        flex-basis: 0;
        margin-bottom: 20px;
    }

    label {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        margin-bottom: 6px;
        color: #bfc5c8;
    }

    #txtNoteDesktop {
        height: 100%
    }

    .buttons {
        display: flex;
        margin-top: 40px;
        margin-bottom: 20px;
        flex-shrink: 0;
        margin-right: auto;
        align-self: flex-start;
        .btn {
            flex-grow: 1;
            flex-shrink: 0;
            min-width: 150px;
            &:not(:last-of-type) {
                margin-right: 20px;
            }
        }
    }

</style>